<template>
  <div class="home contenido">
    <div class="container">
        <HelloWorld 
            msg="Seguros:<br />venta y asesoría"
            idea="Contamos con la asesoría que te acompaña y todo tipo de planes para proteger tu salud, tu vida, tus cosas y proyectos, para que vivas con tranquilidad."
            :imagen="imagen"
         />
         <Botones activo="empresas" />
    </div>
    <EmpresasYcorporativos />
  </div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import HelloWorld from '@/components/HelloWorld.vue'
import Botones from '@/components/Botones.vue'
import EmpresasYcorporativos from '@/views/Empresas-y-corporativos.vue'
import Imagen from '@/assets/images/banner-header-new_01-seguros-venta-y-asesoria.jpg'
export default {
  name: 'Nosotros',
  data() {
      return {
          imagen: Imagen,
      }
  },
  components: {
    HelloWorld,
    Botones,
    EmpresasYcorporativos,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
      $('.table-responsive').scrollLeft(200);
  }
}
</script>
<style>
.rojo {
    color: red;
}
</style>
<style scoped>
.blanco {
    background: #FFF;
}
.contenido {
    min-height: 500px;
}
.gris {
    background: #F2F2F2;
    border-bottom: 8px solid #000;
    margin-top: 180px !important;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 50px, 0% 0%, 100% 0%);
    background: #FFF;
    margin-top: 0;
    position: absolute;
    z-index: 100;
}
h3 {
    font-size: 26px;
    font-weight: 700;
}
.texto {

}
.crm-titulo {
    font-weight: 700;
    font-size: 14px;
}
.crm-subtitulo {
    font-weight: 700;
    font-size: 18px;
}
.img-crm {
    width: 125px;
}
@media only screen and (max-width: 1199px){
    .crm-titulo {
        font-weight: 700;
        font-size: 14px;
    }
    .crm-subtitulo {
        font-weight: 700;
        font-size: 17px;
    }
    .img-crm {
    }
    .triangulo {
        height: 50px;
    }
}
</style>
